module.exports = __webpack_public_path__ + "static/img/nio_empty_wifi.f5b9df44.webp";